"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAYS = void 0;
exports.DAYS = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:DAYS not implemented');
    },
};
//# sourceMappingURL=days.js.map